module.exports = __webpack_public_path__ + "src/libs/img/canada-flag.gif";